import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  expertise: {
    id: 'components.specs.expertise',
    defaultMessage: 'Expertise'
  },
  categories: {
    id: 'components.specs.categories',
    defaultMessage: 'Projects Categories'
  },
  offices: {
    id: 'components.specs.offices',
    defaultMessage: 'Worked With'
  }
})